import { DEFAULT_TEMPLATES } from "@/utils/yjs/constants";
import {
	Command,
	CommandDialog,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
	CommandSeparator,
	CommandShortcut,
} from "@acme/ui/command";
import { createId } from "@paralleldrive/cuid2";
import { useEffect, useRef } from "react";
import { DiNodejsSmall, DiPython } from "react-icons/di";
import { LuArrowLeft } from "react-icons/lu";
import { SiVite } from "react-icons/si";
import { useNavigate } from "react-router";

export const PickTemplatePage = () => {
	const navigate = useNavigate();
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		const handleFocus = () => {
			if (inputRef.current) {
				inputRef.current.focus();
			}
		};

		document.addEventListener("click", handleFocus);
		handleFocus();

		return () => {
			document.removeEventListener("click", handleFocus);
		};
	}, []);

	return (
		<Command>
			<CommandInput ref={inputRef} placeholder="Search for template" />
			<CommandList>
				<CommandEmpty>No results found.</CommandEmpty>
				<CommandGroup heading="Templates">
					{Object.entries(DEFAULT_TEMPLATES).map(([key, template]) => (
						<CommandItem
							key={key}
							onSelect={() => {
								navigate(`/editor/${createId()}?template=${key}`);
							}}
						>
							<template.logo />
							{template.name}
						</CommandItem>
					))}
				</CommandGroup>
				<CommandSeparator />
				<CommandItem onSelect={() => navigate(-1)}>
					<LuArrowLeft />
					Back
				</CommandItem>
			</CommandList>
		</Command>
	);
};

export default PickTemplatePage;
